// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { shapeSepolia as _shapeSepolia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the shapeSepolia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 11011
 * Chain Name: Shape Sepolia Testnet
 * Default Block Explorer: https://shape-sepolia-explorer.alchemy.com
 * Default RPC URL: https://sepolia.shape.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { shapeSepolia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: shapeSepolia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const shapeSepolia = createCommon({
	..._shapeSepolia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
